import React, {useState} from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import IconButton from '@mui/material/IconButton';

export default function InfoTip({ text, size }) {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (e) => {
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };

    return (
        <>
            <IconButton onClick={handleClick} size="small" sx={{ p: 0.25 }}>
                <InfoOutlinedIcon sx={{ fontSize: size || 14, color: 'text.disabled' }} />
            </IconButton>
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                PaperProps={{ sx: { p: 1.5, maxWidth: 300 } }}
            >
                <Typography variant="caption">{text}</Typography>
            </Popover>
        </>
    );
}
